module.exports = __webpack_public_path__ + "static/media/Dashboard.9c82ec55.svg";